import { render, staticRenderFns } from "./BannerPreview.vue?vue&type=template&id=465ae992&scoped=true"
import script from "./BannerPreview.vue?vue&type=script&lang=js"
export * from "./BannerPreview.vue?vue&type=script&lang=js"
import style0 from "./BannerPreview.vue?vue&type=style&index=0&id=465ae992&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ae992",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
